var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_883_22496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.75 14.8571L22.25 19.4286H17.75L13.8125 23.4286V19.4286H8.75V2.28571H26.75V14.8571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.625 0L2 5.71429V26.2857H8.75V32L14.375 26.2857H18.875L29 16V0H7.625ZM26.75 14.8571L22.25 19.4286H17.75L13.8125 23.4286V19.4286H8.75V2.28571H26.75V14.8571Z",
    fill: "#9146FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.375 6.28571H21.125V13.1428H23.375V6.28571Z",
    fill: "#9146FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 6.28571H14.9375V13.1428H17.1875V6.28571Z",
    fill: "#9146FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_883_22496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 32,
    fill: "white",
    transform: "translate(2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitch);
export default __webpack_public_path__ + "static/media/twitch.6424cf9b3b67270c2630a8e1a1cf4f86.svg";
export { ForwardRef as ReactComponent };